import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Job } from "@app/models/rest/job";

@Injectable({
  providedIn: "root"
})
export class JobRestService extends HateoasResourceOperation<Job> {
  constructor() {
    super(Job);
  }
}
